import React from 'react';

const Services = () => {
  return (
    <section id="services">
      <div id="services-content">
        <h2>Servicios</h2>
        <div className="services-grid">
          <div className="service-card">
            <h3>Administración de Sistemas</h3>
            <p>Con una sólida experiencia en la gestión de servidores y entornos de sistemas operativos, soy especialista en plataformas <b>Windows</b>, aunque también tengo amplios conocimientos en <b>Linux</b>. Ofrezco servicios de administración de redes, servidores, y soluciones en la nube, asegurando una infraestructura estable y segura.<br/><br/>Me adapto tanto a entornos físicos como virtuales, gestionando todo de forma remota si es necesario para mantener tus sistemas funcionando de manera eficiente.</p>
          </div>
          <div className="service-card">
            <h3>Soporte Técnico</h3>
            <p>Ofrezco asistencia técnica personalizada para resolver cualquier problema con tus equipos o sistemas, tanto a nivel de hardware como de software.<br/><br/> Ya sea de manera <b>presencial</b> o <b>remota</b>, garantizo una solución rápida y eficiente, asegurando el correcto funcionamiento de tus dispositivos y redes.</p>
          </div>
          <div className="service-card">
            <h3>Montaje y Mantinimiento de Equipos</h3>
            <p>Ofrezco servicios de montaje y configuración de equipos personalizados, adaptados a tus necesidades. Ya sea para gaming, uso profesional o personal, me encargo de seleccionar los componentes adecuados, ensamblarlos y asegurar que todo funcione de manera óptima.<br/><br/>También realizo mantenimiento, optimización y actualizaciones de hardware para mejorar el rendimiento de tus dispositivos.</p>
          </div>
        </div>
        <div className="services-grid">
          <div className="service-card">
            <h3>Desarrollo Web</h3>
            <p>Diseño y desarrollo páginas web a medida, ya sea utilizando gestores de contenido como <b>WordPress</b> o creando soluciones personalizadas desde cero con <b>React</b>, <b>HTML</b>, <b>CSS</b> y <b>JavaScript</b>.<br/><br/> Te ofrezco sitios rápidos, modernos y adaptados a tus necesidades.</p>
          </div>
          <div className="service-card">
            <h3>Desarrollo de Aplicaciones</h3>
            <p>Especializado en la creación de aplicaciones móviles para <b>Android</b>, utilizando tecnologías avanzadas como <b>React Native</b> para ofrecer soluciones multiplataforma. <br/><br/>Desarrollo apps intuitivas y optimizadas, garantizando un rendimiento fluido y una experiencia de usuario atractiva, adaptadas a tus necesidades.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;